module.exports = __webpack_public_path__ + "assets_app/img/logo-synagoge-gr.103ea93a.svg";